export default __webpack_public_path__ + "902999cdd5be15496c7afe79443e0e6e.svg";